<template>
  <div class="root container">
    <router-link :to="{ name: 'Home' }" class="btn has-icon back">
      <i class="material-icons">keyboard_backspace</i>
      <span>Continue Shopping</span>
    </router-link>
    <div class="row n-container">
      <div class="col sm-12 md-8">
        <header class="row">
          <h2>Shopping Cart</h2>
          <h2 class="ml-auto hide-on-laptop-and-up">{{ cartQuantity }} Items</h2>
        </header>
        <div class="divider"></div>

        <template v-if="cartItemsStatus === 1">
          <LinearLoader class="mt-2" text="Loading cart items..." />
        </template>
        <template v-else-if="cartItemsStatus === 2">
          <template v-if="cartItems.length > 0">
            <div v-for="(cartItem, index) in cartItems" :key="index">
              <!-- {{ cartItem }} -->
              <CartItem :cartItem="cartItem" />
            </div>
          </template>
          <p v-else>There are no items in your cart at the moment</p>
        </template>
        <template v-else>
          An Error occured while loading your cart
        </template>
      </div>

      <div class="col sm-12 md-4 more-info">
        <div class="content">
          <header class="text-center primary p-1">
            <h2>Cart Summary</h2>
          </header>

          <main class="p-2 summary">
            <table>
              <tbody>
                <tr>
                  <td>Items No.</td>
                  <td>{{ cartQuantity }}</td>
                </tr>
                <tr>
                  <td>Total</td>
                  <td>$ {{ totalCartValue }}</td>
                </tr>
              </tbody>
            </table>
            <router-link :to="{ name: 'Checkout' }" v-if="cartItems.length > 0"
              class="btn outline block mt-2 text-center">
              Proceed to checkout
            </router-link>
          </main>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-undef */
import { mapGetters, mapActions } from "vuex";
import { AppConfig } from "@/utils/variables";

import CartItem from "./components/CartItem";
import LinearLoader from "@/components/loaders/LinearLoader";

export default {
  name: "Cart",
  metaInfo() {
    return {
      title: `Cart | ${AppConfig.name}`,
    };
  },
  components: {
    CartItem,
    LinearLoader,
  },
  computed: {
    ...mapGetters({
      cartItems: "Cart/cart",
      cartQuantity: "Cart/cartQuantity",
      addCartItemStatus: "Cart/addCartItemStatus",
      addCartItemMessage: "Cart/addCartItemMessage",
      cartItemsStatus: "Cart/cartItemsStatus",

      user: "User/getDetails",
    }),
    totalCartValue() {
      let total = 0;
      this.cartItems.map((cartItem) => {
        total +=
          (cartItem.product.price - cartItem.product.discountPrice) *
          cartItem.quantity;
      });
      return total;
    },
  },
  mounted() {
    T.tabs();

    setTimeout(() => {
      if (this.user.phoneNumber) {
        const input = document.querySelector('#userDetails #contactNumber')
        input.value = this.user.phoneNumber
        console.log(input)
      }
    }, 1000)
  },
  created() {
    this.$store.dispatch("Cart/cartItems");
  },
  methods: {
    ...mapActions("Cart", ["removeCartItem", "removeAllItems"]),
    addToCart(product) {
      let foundItem = this.cart.find(
        (cartItem) => product.id === cartItem.product.id
      );

      if (foundItem) {
        if (foundItem.quantity >= product.stock) {
          // TODO: notify user that they have added all available productt 'x'
        } else {
          this.performAddToCart(product);
        }
      } else {
        this.performAddToCart(product);
      }
    },
    performAddToCart(product) {
      this.$store.dispatch("Cart/addCartItem", product).then(() => {
        if (this.addCartItemStatus === 2) {
          // TODO: notify the user of success
          console.log(`${product.name} Added to cart successfully!`);
        } else if (this.addCartItemStatus === 3) {
          // TODO: notify the user of the error
          console.log("Could not add item to cart!", this.addCartItemMessage);
        }
      });
    },
    removeItem(product) {
      const payload = { product, content: { decrement: true } };
      this.$store.dispatch("Cart/removeItem", payload);
    },
  },
};
</script>

<style lang="scss" scoped>
$col-padding: 0 20px;

.root {
  height: 100%;

  .back {
    width: max-content;
    margin-bottom: 1rem;
  }

  .more-info {

    @media only screen and (min-width: $breakpoint-mobile) {
      padding-left: 15px;
    }

    .content {
      background-color: white;
    }

    .summary {
      span {
        font-size: 1.25rem;
      }
    }
  }
}

.n-container {
  padding: 5px;
  border-radius: 10px;
  background-color: inherit;
  box-shadow: -6px -6px 6px rgba(255, 255, 255, 0.39),
    6px 6px 6px rgba(0, 0, 0, 0.19);

  @media only screen and (min-width: $breakpoint-mobile) {
    padding: 20px;
  }
}
</style>

<style lang="scss">
.theme-dark {
  .n-container {
    box-shadow: -6px -6px 6px #ffffff19,
      6px 6px 6px #000000a5 !important;
  }

  .more-info .content {
    background-color: $dark-light-color !important;
  }
}
</style>
